import React from "react"

interface Props {
    className?: string;
    top?: number;
    left: number;
    color: string;
}

export const Pointer = ({color, left, top = 0.5}: Props): JSX.Element => {
    const style = {
        top: `${top * 100}%`,
        left: `${left * 100}%`
    }

    return (
        <div className={"color-picker-pointer"} style={style}>
            <div className="color-pointer-fill" style={{backgroundColor: color}} />
        </div>
    )
}
